import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormFieldBaseComponent } from '../../form-field-base.component';

@Component({
    selector: 'lib-form-field-paypal-container',
    templateUrl: './form-field-paypal-container.component.html',
    styleUrl: './form-field-paypal-container.component.scss'
})
export class FormFieldPaypalContainerComponent extends FormFieldBaseComponent<any> {
    constructor() {
        super();
        this.viewControl = new FormControl();
        this.showRequiredIndicator = true;
    }
}
